import React from 'react';
import PropTypes from 'prop-types';

import { formatEntryDate, formatEntryTime } from '../../utils/date';
import { yardsToFurlongs } from '../../utils/distance';
import Definition from '../../shared/Definition';
import RaceCardLink from '../../shared/links/RaceCardLink';
import { JockeyLink } from '../../shared/links/ProfileLink';
import PriceButton from '../../shared/price/PriceButton';

class DeclaredBox extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            overnightRaces: [],
        };
    }

    componentDidMount = () => {
        const races = this.props.entries
        .filter(({ raceStatusCode }) => raceStatusCode === 'O')
        .map(entry => ({
            ...entry,
            comment: (this.props.comments.find(c =>
                c.raceInstanceUid === entry.raceInstanceUid
            ) || {}).individualComment,
        }));

        this.setState({
            overnightRaces: races,
        });
    }

    render() {
        if (!this.state.overnightRaces.length) {
            return null;
        }
        return (
            <div className="js-diffusionTopicSettingsRace">
                {this.state.overnightRaces.map(race => (
                    <div className="hp-declared" key={race.raceInstanceUid}>
                        <dl className="hp-declared__box">
                            <strong className="hp-declared__title">DECLARED</strong>
                            <Definition
                                term={formatEntryDate(race.raceDatetime, 'ddd, DD MMMM YYYY')}
                            >
                                <RaceCardLink {...race} >
                                    {formatEntryTime(race.raceDatetime)}
                                    &nbsp;
                                    {race.courseStyleName}
                                </RaceCardLink>
                                &nbsp;
                                <span className="hidden-sm-down">
                                    {yardsToFurlongs(race.distanceYard)}
                                </span>
                            </Definition>
                            {race.jockeyStyleName && race.jockeyLast14Days &&
                                <Definition
                                    term="Jockey"
                                >
                                    <JockeyLink {...race} />
                                    <span className="hp-declared__jockeyStats">
                                        &nbsp;(Last 14 days:&nbsp;
                                        {race.jockeyLast14Days.wins}
                                        -
                                        {race.jockeyLast14Days.runs}
                                        ,
                                        {race.jockeyLast14Days.percent}
                                        %)
                                    </span>
                                </Definition>
                            }
                            <Definition
                                term="RPR"
                                description={race.rpPostmark}
                            />
                            <Definition
                                className="hp-declared__comments"
                                term="Comment"
                                description={race.comment}
                            />
                        </dl>
                        <PriceButton
                            horseName={this.props.horseName}
                            {...race}
                        />
                    </div>
                ))}
            </div>
        );
    }

}

DeclaredBox.propTypes = {
    entries: PropTypes.arrayOf(PropTypes.shape({
        courseStyleName: PropTypes.string.isRequired,
        courseUid: PropTypes.number.isRequired,
        distanceYard: PropTypes.number.isRequired,
        jockeyStyleName: PropTypes.string,
        jockeyUid: PropTypes.number,
        jockeyLast14Days: PropTypes.shape({
            wins: PropTypes.number,
            runs: PropTypes.number,
            percent: PropTypes.number,
        }),
        raceDatetime: PropTypes.string.isRequired,
        raceInstanceUid: PropTypes.number.isRequired,
        raceStatusCode: PropTypes.string.isRequired,
        rpPostmark: PropTypes.number,
    })),
    horseName: PropTypes.string.isRequired,
    comments: PropTypes.arrayOf(PropTypes.shape({
        individualComment: PropTypes.string,
        raceInstanceUid: PropTypes.number.isRequired,
    })),
};

export default DeclaredBox;



// WEBPACK FOOTER //
// ./src/js/horse/declaredBox/DeclaredBox.jsx